@if (href) {
  <a
    [href]="href"
    [class]="type + ' ' + size"
    [class.disabled]="disabled"
    [class.fullwidth]="fullwidth"
    [attr.rel]="isInternalLink ? null : 'noopener noreferrer'"
    [attr.target]="isInternalLink ? null : '_blank'"
  >
    <ng-container *ngTemplateOutlet="inner" />
  </a>
} @else {
  <button [type]="isSubmit ? 'submit' : 'button'" [class]="type + ' ' + size" [disabled]="disabled" [class.fullwidth]="fullwidth">
    <ng-container *ngTemplateOutlet="inner" />
  </button>
}

<ng-template #inner>
  <ng-content />
</ng-template>
